// extracted by mini-css-extract-plugin
export default {"filtersList":"sections-module___filtersList___cf2c5be4","header":"sections-module___header___e747d3c6"};